import {Grid} from "@mui/material";
import React, {useMemo} from "react";
import {mapSetState, SetState} from "../../util/FormHandlers";
import {DateField} from "../date-field/DateField";


export function DateFilter<Filter extends { [P in PropertyName]: string | undefined }, PropertyName extends keyof Filter>(
    {filter, setFilter, property, label}: {
        filter: Filter,
        setFilter: SetState<Filter>,
        property: PropertyName,
        label: string,
    }) {
    const setDateValue = useMemo(
        () => mapSetState(setFilter, property),
        [setFilter, property],
    );

    return (
        <Grid size={{md: 2, xs: 6}} minWidth={185}>
            <DateField
                label={label}
                value={filter[property]}
                setValue={setDateValue}
                slotProps={{
                    field: {clearable: true}
                }}
            />
        </Grid>
    );
}
